import { render, staticRenderFns } from "./AttachmentGallery.vue?vue&type=template&id=110c1486&scoped=true"
import script from "./AttachmentGallery.vue?vue&type=script&lang=js"
export * from "./AttachmentGallery.vue?vue&type=script&lang=js"
import style0 from "./AttachmentGallery.vue?vue&type=style&index=0&id=110c1486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110c1486",
  null
  
)

export default component.exports